import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2a78c648"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex col grow",
  style: {"padding-right":"12px","padding-left":"12px"}
}
const _hoisted_2 = { class: "flex grow wrap" }
const _hoisted_3 = { class: "flex wrap" }
const _hoisted_4 = {
  ref: "stateLabel",
  class: "text-muted",
  style: {"display":"none","color":"#d90000"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Accepter les conditions d'utilisation", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeCheckBox = _resolveComponent("SeCheckBox")!
  const _component_SeButton = _resolveComponent("SeButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_SeInput, {
          class: "field",
          ref: "firstname",
          placeholder: _ctx.Lang.getI18N('firstname'),
          value: ""
        }, null, 8, ["placeholder"]),
        _createVNode(_component_SeInput, {
          class: "field",
          ref: "surname",
          placeholder: _ctx.Lang.getI18N('surname'),
          value: ""
        }, null, 8, ["placeholder"])
      ]),
      _createVNode(_component_SeInput, {
        ref: "email",
        placeholder: "Email",
        value: ""
      }, null, 512),
      _createVNode(_component_SeInput, {
        ref: "phone",
        placeholder: _ctx.Lang.getI18N('phone-number'),
        value: ""
      }, null, 8, ["placeholder"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SeInput, {
          ref: "password",
          placeholder: _ctx.Lang.getI18N('password'),
          type: "password",
          value: ""
        }, null, 8, ["placeholder"]),
        _createVNode(_component_SeInput, {
          ref: "passwordConf",
          placeholder: _ctx.Lang.getI18N('password-confirm'),
          type: "password",
          value: ""
        }, null, 8, ["placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, " [Alert Message] ", 512),
    _createVNode(_component_SeCheckBox, { ref: "legalTerms" }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeButton, {
      ref: "registerBtn",
      onPress: _ctx.register,
      style: {"height":"50px"}
    }, {
      default: _withCtx(() => [
        _createTextVNode("Inscription")
      ]),
      _: 1
    }, 8, ["onPress"]),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLogin())),
      class: "link-text"
    }, " Vous possedez déja un compte ? Se connecter ")
  ], 64))
}